function getDate(days) {
    
    const nth = function(d) {
        if (d > 3 && d < 21) return 'th';
        switch (d % 10) {
        case 1:  return "st";
        case 2:  return "nd";
        case 3:  return "rd";
        default: return "th";
        }
    }

    var monthNames = new Array("January","February","March","April","May","June","July","August","September","October","November","December");    
    var now = new Date();   
    now.setDate(now.getDate() + days);   
    var nowString =  monthNames[now.getMonth()] + " " +now.getDate() + nth(now.getDate()) + ", " + now.getFullYear(); 
    document.write(nowString); 
}